import React, { useState } from 'react';
import Button from '../../../../components/UI/Button';
import Checkbox from '../../../../components/UI/Checkbox';
import SubheadingWithDivider from '../UI/SubheadingWithDivider';
import HorizontalDivider from '../UI/HorizontalDivider';

import css from './ElectronicConsent.module.scss';
import { DocumentTypes } from '.';

interface ElectronicConsentProps {
  setElectronicConsentViewed: (newState) => void;
  docs: Map<string, string> | undefined;
}

export default function ElectronicConsent({
  setElectronicConsentViewed,
  docs
}: ElectronicConsentProps) {
  const [read, setRead] = useState<boolean>(false);
  const pdfUrl = `${docs?.get(DocumentTypes.ElectronicDisclosure)}#toolbar=0`;

  return (
    <>
      <SubheadingWithDivider />
      <h1>Electronic Consent</h1>
      <HorizontalDivider />
      <iframe width="100%" height="600px" src={pdfUrl} />
      <HorizontalDivider />
      <div className={css.checkboxContainer}>
        <Checkbox
          id="read-terms"
          checked={read}
          onChange={() => {
            setRead(!read);
          }}
          label={
            <p className={css.checkboxLabel}>
              I have read and agree to the above terms and conditions
            </p>
          }
        />
      </div>
      <Button
        text="I agree"
        onClick={() => {
          setElectronicConsentViewed(true);
        }}
        disabled={!read}
      />
      <p className={css.footerText}>
        By submitting this application, you agree to allow First National Bank
        of Omaha (FNBO®) to review your credit history.
      </p>
    </>
  );
}
